import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useTranslation from "../application/translation";
import Button from "@material-ui/core/Button";
import { CloudDownload } from "@material-ui/icons";

export default function QandA() {
    const translation = useTranslation();
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular,
        },
    }));

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h6">
                {translation.qa_header}
            </Typography>
            <br />
            <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon aria-hidden="true" />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                aria-label={translation.qa_q1_header}
            >
                    <Typography className={classes.heading}>{translation.qa_q1_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q1_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q2_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q2_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q3_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q3_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon aria-hidden="true" />}
                aria-controls="panel4a-content"
                id="panel4a-header"
                aria-label={translation.qa_q4_header}
            >
                    <Typography className={classes.heading}>{translation.qa_q4_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q4_answer} <a
                            href="https://www.willistowerswatson.com/sv-SE/Notices/privacy-notice-crb"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={translation.qa_q4_here}
                        >
                            {translation.qa_q4_here}
                        </a>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5a-content"
                    id="panel5a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q5_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q5_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel6a-content"
                    id="panel6a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q6_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q6_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel7a-content"
                    id="panel7a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q7_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q7_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel8a-content"
                    id="panel8a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q8_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q8_answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel9a-content"
                    id="panel9a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q9_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q9_answer1} <a href={process.env.PUBLIC_URL + "/Documents/" + translation.doctorAttFile} target="_blank" rel="noopener noreferrer">{translation.qa_q4_here}</a> <br />
                        {translation.qa_q9_answer2}
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel9a-content"
                    id="panel9a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q11_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q11_answer} <br />

                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel10a-content"
                    id="panel10a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q10_header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q10_answer1} <a href={translation.qa_q10_answer2} target="_blank" rel="noopener noreferrer">{translation.qa_q4_here}</a>.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            {/*<Accordion>*/}
            {/*    <AccordionSummary*/}
            {/*        expandIcon={<ExpandMoreIcon />}*/}
            {/*        aria-controls="panel10a-content"*/}
            {/*        id="panel10a-header"*/}
            {/*    >*/}
            {/*        <Typography className={classes.heading}>{translation.qa_q12_header}</Typography>*/}
            {/*    </AccordionSummary>*/}
            {/*    <AccordionDetails>*/}
            {/*        <Typography variant="body2">*/}
            {/*            {translation.qa_q12_answer1} <br />*/}
            {/*            {translation.qa_q12_answer2} <br />*/}
            {/*            {translation.qa_q12_answer3} <br />*/}
            {/*        </Typography>*/}
            {/*    </AccordionDetails>*/}
            {/*</Accordion>*/}
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel10a-content"
                    id="panel10a-header"
                >
                    <Typography className={classes.heading}>{translation.qa_q13_header} </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {translation.qa_q13_answer1} <br />z
                        <a href={translation.qa_q13_answer3} target="_blank" rel="noopener noreferrer">{translation.qa_q13_answer2}</a> <br />
                        <a href={translation.qa_q13_answer5} target="_blank" rel="noopener noreferrer">{translation.qa_q13_answer4}</a> <br />
                        <a href={translation.qa_q13_answer7} target="_blank" rel="noopener noreferrer">{translation.qa_q13_answer6}</a> <br />
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel11a-content"
                    id="panel11a-header"
                >
                    <Typography className={classes.heading}>{translation.qanda_11_Header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        <a href={`${process.env.PUBLIC_URL}/Documents/tc/${translation.qandatandcppifile}`} target="_blank" rel="noopener noreferrer">{translation.qanda_11_Header} {translation.ppi}</a> <br />
                        <a href={`${process.env.PUBLIC_URL}/Documents/tc/${translation.qandatandclpifile}`} target="_blank" rel="noopener noreferrer">{translation.qanda_11_Header} {translation.lpi}</a> <br />
                        <a href={`${process.env.PUBLIC_URL}/Documents/tc/${translation.qandatandclpilofile}`} target="_blank" rel="noopener noreferrer">{translation.qanda_11_Header} {translation.lpilo}</a> <br />
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );

};